import { assign } from 'lodash';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from '@medsurf/flat-validators';

@Component({
    selector: 'medsurf-slide-edit-shared-link-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './shared-link-form.component.html',
    styleUrls: ['./shared-link-form.component.scss'],
    standalone: false
})
export class SharedLinkFormComponent {
  #isSubmitted = signal(false);
  #annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType | null;
  annotationLinkForm = new FormGroup(
    {
      type: new FormControl<FlatModels.LinkEntityModels.LinkType>('Slide'),
      link: new FormControl<string | number>(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.LinkEntityModels.LinkSchema
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Annotation
    this.slideAuthorFacade.currentSelectedSlideAnnotation$.pipe(takeUntilDestroyed()).subscribe((annotation) => {
      this.#annotation = structuredClone(annotation);
      if (this.#annotation && this.#annotation.link) {
        this.annotationLinkForm.reset({
          type: annotation?.link?.type || 'Slide',
          link: annotation?.link?.link,
        });
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.annotationLinkForm.invalid || !this.annotationLinkForm) {
      return;
    }
    this.#isSubmitted.set(true);
    
    // Update Annotation
    const annotation = assign(
      this.#annotation,
      {
        link: {
          type: this.annotationLinkForm.value.type,
          link: this.annotationLinkForm.value.link,
        }
      }
    );
    this.slideAuthorFacade.requestUpdateAnnotation(annotation, 'history.annotation_update_link').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.annotationLinkForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
